import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
export function useProfile(userId) {
    const [profile, setProfile] = useState(null);
    const [dogs, setDogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tick, setTick] = useState(0);
    useEffect(() => {
        if (!userId) {
            setProfile(null);
            setDogs([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        Promise.all([
            supabase.from('profiles').select('*').eq('id', userId).single(),
            supabase.from('dogs').select('*').eq('owner_id', userId).eq('is_active', true).order('name'),
        ]).then(([profileRes, dogsRes]) => {
            if (profileRes.error)
                setError(profileRes.error.message);
            else
                setProfile(profileRes.data);
            if (dogsRes.error)
                setError(dogsRes.error.message);
            else
                setDogs(dogsRes.data);
            setLoading(false);
        });
    }, [userId, tick]);
    return {
        profile,
        dogs,
        loading,
        error,
        reload: () => setTick((t) => t + 1),
    };
}
